import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { LogOut, LogIn, UserPlus } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";

interface HeaderProps {
  session: any;
}

const Header = ({ session }: HeaderProps) => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      navigate("/auth");
    } catch (error) {
      console.error("Error signing out:", error);
      toast({
        title: "Error",
        description: "Failed to sign out. Please try again.",
        variant: "destructive",
      });
    }
  };

  const handleAuthNavigation = (mode: 'sign-in' | 'sign-up') => {
    navigate("/auth", { state: { mode } });
  };

  return (
    <header className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6 sm:mb-8 bg-white/80 backdrop-blur-sm rounded-lg shadow-sm p-4">
      <div className="flex flex-col">
        <h1 className="text-xl sm:text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-700 to-purple-900">
          Fuzion Social
        </h1>
        <div className="text-sm text-gray-600">
          Powered by{" "}
          <a 
            href="https://localleadconnector.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-purple-600 hover:text-purple-800 transition-colors"
          >
            Local Lead Connector
          </a>
        </div>
      </div>

      <div className="flex gap-2 w-full sm:w-auto">
        {session ? (
          <Button
            variant="outline"
            size="sm"
            onClick={handleSignOut}
            className="gap-2 text-gray-600 hover:text-gray-900 w-full sm:w-auto"
          >
            <LogOut className="h-4 w-4" />
            Sign Out
          </Button>
        ) : (
          <>
            <Button
              variant="outline"
              size="sm"
              onClick={() => handleAuthNavigation('sign-in')}
              className="gap-2 text-gray-600 hover:text-gray-900 w-full sm:w-auto"
            >
              <LogIn className="h-4 w-4" />
              Sign In
            </Button>
            <Button
              variant="default"
              size="sm"
              onClick={() => handleAuthNavigation('sign-up')}
              className="gap-2 w-full sm:w-auto bg-purple-600 hover:bg-purple-700"
            >
              <UserPlus className="h-4 w-4" />
              Sign Up
            </Button>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;